import { render, staticRenderFns } from "./IssueNotification.vue?vue&type=template&id=4acfd632&scoped=true"
import script from "./IssueNotification.vue?vue&type=script&lang=js"
export * from "./IssueNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acfd632",
  null
  
)

export default component.exports